import { Injectable } from '@angular/core';

@Injectable()
export class LoaderService {
    show(id) {
        document.getElementById(id).style.display = 'block';
    }

    hide(id) {
        document.getElementById(id).style.display = 'none';
    }
}